import { render } from "./TestOurService.vue?vue&type=template&id=710d9489&ts=true"
import script from "./TestOurService.vue?vue&type=script&lang=ts"
export * from "./TestOurService.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__